import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Feature } from "ol";
import { useDrawingContext } from "../../Contexts/DrawingContext";

export interface ISketchProps {
    feature: Feature;
}
export const SketchProps = ({ feature }: ISketchProps): JSX.Element => {
    const [note, setNote] = useState<string>("");
    const [label, setLabel] = useState<string>("");
    const { onNoteChange, onDeleteFeature, selectedFeature, setSelectedFeature } = useDrawingContext();

    useEffect(() => {
        setNote(feature.get("DESCRIPTION"));
        setLabel(feature.get("NR"));
        feature.on("propertychange", () => setLabel(feature.get("NR")));
    }, []);

    const onChange = (e) => {
        setNote(e.target.value);
        feature.set("DESCRIPTION", e.target.value);
        onNoteChange();
    };

    return (
        <div
            className={classNames("draw-note", {
                selected: selectedFeature && feature.get("TEMPID") === selectedFeature.get("TEMPID")
            })}
        >
            <div className="label">{label}</div>
            <input
                type="text"
                placeholder="Piezīmes"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
                onFocus={() => setSelectedFeature(feature)}
                value={note}
            />
            <div className="draw-delete" onClick={() => onDeleteFeature(feature)}>
                <span className="icon-conexus-bin"></span>
            </div>
        </div>
    );
};
